import instagram from "../assets/instagram.png";
import _instagram from "../assets/_instagram.png";
import whatsapp from "../assets/whatsapp.png";
import _whatsapp from "../assets/_whatsapp.png";
import email from "../assets/email.png";
import _email from "../assets/_email.png";

import { useContext } from "react";
import { ThemeContext } from "../ThemeContext.js";

const Footer = () => {
  const socials = [
    "https://www.instagram.com/",
    "https://wa.me/",
    "mailto:demetri@hotmail.com",
  ];

  const { theme } = useContext(ThemeContext);

  const images = [instagram, whatsapp, email];
  const _images = [_instagram, _whatsapp, _email];
  return (
    <footer className="footer">
      <div className="social-container">
        {socials.map((social, index) => {
          return (
            <a key={social} href={social} target="_blank" rel="noreferrer">
              <img
                alt="social-icon"
                className="footer-social-img"
                src={theme === "dark" ? _images[index] : images[index]}
              />
            </a>
          );
        })}
      </div>
      <p className="footer-text">
        Made with ❤️ for Demetrious Mizzawi by{" "}
        <a
          className="link"
          href="https://rolandbrake.github.io"
          target="_blank"
          rel="noreferrer"
        >
          Roland Brake
        </a>{" "}
        {new Date().getFullYear()}.
      </p>
    </footer>
  );
};

export default Footer;
